<template>
  <router-view />
</template>

<script>
export default {
  name: 'PayrollOverviews'
};
</script>

<style lang="scss" scoped></style>
